import Const from '../constants'
import axiosApiInstance from '@/interceptors'
import { NotificationSelected } from '@/models/Notification'

class NotificationService {
  getNotificationCount(notification_type: number) {
    return axiosApiInstance.get(Const.api_url + 'members/me/notification/count/' + notification_type)
  }

  getNotificationUnread(limit: number, page: number, group_id?: number) {
    if (group_id) {
      return axiosApiInstance.get(Const.api_url + 'members/me/notification/unread?limit=' + limit + '&page=' + page + '&group_id=' + group_id)
    } else {
      return axiosApiInstance.get(Const.api_url + 'members/me/notification/unread?limit=' + limit + '&page=' + page)
    }
  }

  getNotificationLike(limit: number, page: number) {
    return axiosApiInstance.get(Const.api_url + 'members/me/notification/like?limit=' + limit + '&page=' + page)
  }

  getNotificationFavorite(limit: number, page: number) {
    return axiosApiInstance.get(`${Const.api_url}members/me/favorite?limit=${limit}&page=${page}`)
  }

  getFavoriteCount() {
    return axiosApiInstance.get(`${Const.api_url}members/me/count-favorite`)
  }

  markReadAllLike() {
    return axiosApiInstance.get(`${Const.api_url}members/me/notification/mark-read-all-like`)
  }

  markReadedNotification(notifications: NotificationSelected) {
    return axiosApiInstance.post(Const.api_url + 'members/me/notification/set-notification-is-seen', notifications)
  }

  getUnreadMentionList(params: { page: number, limit: number, target_id?: number }) {
    return axiosApiInstance.get(
      Const.api_url + 'members/me/notification/unread-type-mention',
      {
        params: params
      }
    )
  }

  getUnreadMentionCount(target_id?: number) {
    return axiosApiInstance.get(Const.api_url + 'members/me/notification/count-unread-type-mention', {
      params: { target_id }
    })
  }
}

export default new NotificationService
